"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("../utils/helpers");
var StyledBox = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  color: ", ";\n  display: flex;\n  width: ", ";\n  max-width: 100%;\n  flex-direction: column;\n  justify-content: ", ";\n  align-items: ", ";\n  z-index: ", ";\n  min-height: ", ";\n  box-shadow: ", ";\n  border: ", ";\n  ", ";\n  @media (", ") {\n    min-height: ", ";\n  }\n  @media (", ") {\n    min-height: ", ";\n  }\n  @media (", ") {\n    min-height: ", ";\n  }\n"], ["\n  position: relative;\n  background-color: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  color: ", ";\n  display: flex;\n  width: ", ";\n  max-width: 100%;\n  flex-direction: column;\n  justify-content: ", ";\n  align-items: ", ";\n  z-index: ", ";\n  min-height: ", ";\n  box-shadow: ", ";\n  border: ", ";\n  ", ";\n  @media (", ") {\n    min-height: ", ";\n  }\n  @media (", ") {\n    min-height: ", ";\n  }\n  @media (", ") {\n    min-height: ", ";\n  }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor || 'transparent';
}, function (_a) {
    var theme = _a.theme, topSpacing = _a.topSpacing;
    return (topSpacing ? theme.spacing[topSpacing] : 0);
}, function (_a) {
    var theme = _a.theme, bottomSpacing = _a.bottomSpacing;
    return bottomSpacing ? theme.spacing[bottomSpacing] : 0;
}, function (_a) {
    var theme = _a.theme, leftSpacing = _a.leftSpacing;
    return (leftSpacing ? theme.spacing[leftSpacing] : 0);
}, function (_a) {
    var theme = _a.theme, rightSpacing = _a.rightSpacing;
    return (rightSpacing ? theme.spacing[rightSpacing] : 0);
}, function (_a) {
    var color = _a.color, backgroundColor = _a.backgroundColor;
    return color || (0, helpers_1.invertColor)(backgroundColor || '#fff', true);
}, function (_a) {
    var width = _a.width;
    return width || '100%';
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent || 'flex-start';
}, function (_a) {
    var alignItems = _a.alignItems;
    return alignItems || 'stretch';
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex || 'auto';
}, function (_a) {
    var xsHeight = _a.xsHeight;
    return xsHeight || 0;
}, function (_a) {
    var elevation = _a.elevation;
    return (0, helpers_1.elevationToBoxShadow)(elevation);
}, function (_a) {
    var bordered = _a.bordered, theme = _a.theme;
    return (bordered ? "1px solid " + theme.colors.mediumGray : '0');
}, function (_a) {
    var backgroundImageUrl = _a.backgroundImageUrl;
    return backgroundImageUrl && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-position: center center;\n      background-size: cover;\n      background-image: url(", ");\n    "], ["\n      background-position: center center;\n      background-size: cover;\n      background-image: url(", ");\n    "])), backgroundImageUrl);
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.sm;
}, function (_a) {
    var smHeight = _a.smHeight;
    return smHeight || 0;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.md;
}, function (_a) {
    var mdHeight = _a.mdHeight;
    return mdHeight || 0;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.lg;
}, function (_a) {
    var lgHeight = _a.lgHeight;
    return lgHeight || 0;
});
var Box = function (_a) {
    var elevation = _a.elevation, rest = __rest(_a, ["elevation"]);
    return react_1.default.createElement(StyledBox, __assign({ elevation: elevation }, rest));
};
exports.default = Box;
var templateObject_1, templateObject_2;
